import Dialog from 'global/guides/Dialog'
import { useAuth } from 'hooks'
import { hasPermission } from 'hooks/useBackendMenu'
import {
    createRegrasCalculoSchema,
    RegraCalculoPresenter,
    regrasCalculo,
} from 'service/api'
import { toast } from 'sonner'
import { updateRascunho } from 'templates/Cadastro/Funcionarios/organismos/modals/Adicionar'
import { horasExtrasModel as defaultValues } from '../../constants'
import FormRegraCalculo from '../forms/FormRegraCalculo'

export default function AdicionarRegrasCalculo() {
    const {
        decoded: { cliente: clienteId },
    } = useAuth()
    const { mutateAsync, isLoading } = regrasCalculo.mutations.useCreate({
        invalidateQuery: true,
        onSuccess: res => {
            updateRascunho({ regraCalculo: res.id })
            toast.success('Regra de cálculo adicionada com sucesso')
        },
        onError: e => {
            toast.error(e.message)
        },
    })

    return (
        <Dialog.Root
            open={hasPermission(['create', 'RegrasDeCálculo'])}
            width="62rem"
            defaultValues={defaultValues}
            schema={createRegrasCalculoSchema}
            loading={isLoading}
            onSubmit={(data: RegraCalculoPresenter) =>
                mutateAsync({ ...data, clienteId })
            }
        >
            <Dialog.Title>Adicionar regra de cálculo</Dialog.Title>
            <Dialog.Content dividers>
                <FormRegraCalculo />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
